import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import SubcategoriesEditForm from './SubcategoriesEditForm';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { fetchSubcategory } from 'store/actions/subcategories/fetchSubcategories';
import { updateSubcategory } from 'store/actions/subcategories/updateSubcategories';
import fetchResourceAndLocalisationById from 'components/hoc/fetchResourceAndLocalisationById';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';

class SubcategoriesEditContainer extends React.Component {
    formatFormResults = (values) => {
        const {
            system,
        } = this.context.config.language;

        let baseValues = {
            category_id: values.category_id,
            ...values.localisation[system],
        };

        const localisationValues = utils.filterEmptyValues(values.localisation);

        return {
            base: baseValues,
            localisation: localisationValues,
        };
    }

    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        if (utils.isEmpty(values)) {
            return null;
        }

        const convertedValues = this.formatFormResults(values);

        return new Promise((resolve, reject) => {
            return dispatchForm({
                onError: () => {
                    reject();
                },
                onSuccess: () => {
                    resolve(history.push(`/subcategories/${ id }/show`));
                },
                formValues: convertedValues,
                id: id,
            });
        });
    }

    render() {
        const {
            data,
            localisation,
            resourceFetchLoading,
            resourceFetchFailed,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.subcategories.title'),
                link: `/subcategories`,
            },
            {
                label: data.name,
                link: `/subcategories/${ data.id }/show`,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.subcategories.actions.edit') } />

                    <Actions>
                        <ListButton url='/subcategories' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <SubcategoriesEditForm
                            data={ data }
                            localisation={ localisation }
                            form='subcategories_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

SubcategoriesEditContainer.contextTypes = {
    config: PropTypes.object,
};

SubcategoriesEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object,
    id: PropTypes.number,
    localisation: PropTypes.object,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateSubcategory(values));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        null,
        mapDispatchToProps,
    ),
    fetchResourceAndLocalisationById({
        resource: 'subcategories',
        action: fetchSubcategory,
    })
);

export default enhance(SubcategoriesEditContainer);



// WEBPACK FOOTER //
// ./src/pages/subcategories/edit/SubcategoriesEditContainer.js